import React from 'react';
import { useWorkspace } from '../hooks/useWorkspace';
import { WORKSPACE_INFO } from '../workspaces';

/**
 * Selettore dello spazio di lavoro (Completo / Videomaker / Social).
 *   size="md"    etichetta completa (header pagina)
 *   size="sm"    etichetta corta (mobile)
 *   size="icon"  solo icone, piena larghezza
 *   size="block" etichetta corta, piena larghezza (sidebar, menu mobile)
 */
export default function WorkspaceSwitch({ size = 'md' }) {
  const { workspace, setWorkspace } = useWorkspace();
  const iconOnly = size === 'icon';
  const full = iconOnly || size === 'block';
  return (
    <div role="radiogroup" aria-label="Spazio di lavoro"
      style={{
        display: full ? 'flex' : 'inline-flex', width: full ? '100%' : 'auto',
        background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 10, padding: 3, gap: 2, boxSizing: 'border-box',
      }}>
      {Object.entries(WORKSPACE_INFO).map(([k, w]) => {
        const on = workspace === k;
        return (
          <button key={k} role="radio" aria-checked={on} aria-label={w.label}
            onClick={() => setWorkspace(k)} title={`${w.label} — ${w.desc}`}
            style={{
              flex: full ? 1 : 'none', minWidth: 0,
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
              border: 'none', cursor: 'pointer', minHeight: 30,
              padding: size === 'md' ? '7px 12px' : '6px 8px', borderRadius: 8, fontSize: 12.5, fontWeight: 600, fontFamily: 'inherit',
              background: on ? 'var(--bg2)' : 'transparent',
              color: on ? 'var(--text)' : 'var(--text-muted)',
              boxShadow: on ? 'var(--shadow-sm)' : 'none',
              touchAction: 'manipulation', transition: 'background 0.15s, color 0.15s',
            }}>
            <w.Icon size={14} style={{ flexShrink: 0, color: on ? 'var(--cyan)' : 'currentColor' }} />
            {!iconOnly && (size === 'md' ? w.label : w.short)}
          </button>
        );
      })}
    </div>
  );
}

/**
 * Invito (una tantum) a scegliere lo spazio di lavoro, mostrato in Home finché
 * l'utente non ha scelto. Scegliere "Completo" lo chiude lasciando tutto com'è.
 */
export function WorkspacePrompt() {
  const { scelto, setWorkspace } = useWorkspace();
  if (scelto) return null;
  return (
    <div style={{
      background: 'var(--surface)', border: '1px solid rgba(0,212,255,0.3)', borderRadius: 12,
      padding: '14px 16px', marginBottom: 20,
    }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)' }}>Che lavoro fai in agenzia?</div>
      <div style={{ fontSize: 12.5, color: 'var(--text-muted)', marginTop: 3, marginBottom: 12, lineHeight: 1.5 }}>
        Scegli il tuo spazio: EdenFlow ti mostra solo le sezioni che usi e una bacheca con quello che devi fare.
        Puoi cambiarlo quando vuoi dalla barra laterale (su telefono: Menu).
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 8 }}>
        {['videomaker', 'social', 'completo'].map(k => {
          const w = WORKSPACE_INFO[k];
          return (
            <button key={k} onClick={() => setWorkspace(k)}
              style={{
                display: 'flex', alignItems: 'flex-start', gap: 10, textAlign: 'left', cursor: 'pointer',
                background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10, padding: '11px 12px',
                color: 'var(--text)', font: 'inherit', touchAction: 'manipulation', transition: 'border-color 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--cyan)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; }}>
              <w.Icon size={18} color="var(--cyan)" style={{ flexShrink: 0, marginTop: 1 }} />
              <span>
                <span style={{ display: 'block', fontSize: 13, fontWeight: 700 }}>{w.label}</span>
                <span style={{ display: 'block', fontSize: 11.5, color: 'var(--text-dim)', marginTop: 2, lineHeight: 1.4 }}>{w.desc}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
